export function toUrl(url) {
    return `url('${url}')`;
}
